import ajax from '@/resources/myApi';
import vm from '@/main';
//import sendEmailstDto from './dto';

const sendEmailsService = {
  //getSendEmails,
  createWithReq,
  getEmailTemplate,
  getEmailTemplatesbycategory
};

/*async function getSendEmails(companyId) {
  try {
    // const filter = encodeURIComponent(`{ companyId: ${companyId} }`);

    // const { data } = await ajax.get(`api/requirement?pageSize=50&filters=${filter}`, {
      console.log(companyId, 'Service')
    const { data } = await ajax.get(`api/requirement/${companyId}/Sourced`, {
      name: 'get requirements by company id',
    });

    return data;

    //return result.data.map(item => new sendEmailstDto(item));
  } catch {}
}*/

async function createWithReq(body) {
  try {
    const result = await ajax.post('api/EmailQueue', {
      name: 'Send email',
      body,
    });
    (result.status==200)?vm.$snotify.success('Email sent successfully.', 'Send Email'):'';
    return result.data;
  } catch {}
}

async function getEmailTemplate(id) {
  try {
    const result = await ajax.get(`api/EmailTemplate/${id}`, {
      name: 'Send email',
    });

    return result.data;
  } catch {}
}

async function getEmailTemplatesbycategory(categoryId) {
  try {
    const result = await ajax.get(`api/EmailTemplate/ByCategory?categroyId=${categoryId}`, {
      name: 'Send email',
    });

    return result.data;
  } catch {}
}

export default sendEmailsService;
